
const baseUrl = 'https://api.ticket.test.bassetti-ites.in/v1'; //asset, ticket api
const apiAdminURL = 'https://api.admin.test.bassetti-ites.in/api/v1'; //finance api
// const baseUrl = 'http://localhost:4002/v1'; //asset, ticket api local
// const apiAdminURL = 'http://localhost:4000/api/v1'; //finance local

export const environment = {
  production: false,
  defaultLanguage: {
    code: 'en',
    name: 'English',
  },
  languages: [
    { name: 'France', code: 'fr' },
    { name: 'English', code: 'en' },
  ],

  apiBaseUrl: baseUrl,
  apiAdminUrl: apiAdminURL,
  apiCommonUrl: `${baseUrl}/common`,
  apiUserUrl: `${apiAdminURL}/user`,
  apiSuperUserUrl: `${apiAdminURL}/super-user`,
  apiOrganizationUrl: `${apiAdminURL}/organization`,
  authUrl: `https://auth.test.bassetti-ites.in`,
  authApiUrl: `https://api.auth.test.bassetti-ites.in/api/v1/auth`,
  authTokenParamKey: 'rf_tkn',
};
